import React, {useEffect, useState} from 'react';
import {Box, CardContent, Grid, IconButton, List, ListItem, Typography} from '@deere/fuel-react';
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {useStyles} from "../shared/styles/Ratings";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {RatingYesNoFeedback} from "./RatingYesNoFeedback";
import {ChartsGraphs} from "@deere/ux.uxframe-react";
import {RatingCampaignsData} from './RatingCampaignsData';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {COMMENT_VISIBLE_TITLE, LIKERT_SCALE_LIST, LIKERT_SCALE_LIST_2, LIKERT_SCALE_LIST_3, LIKERT_SCALE_LIST_4} from "../shared/Constants";
import {sortAlphaNum} from "../shared/utils";
import {RatingCommentDisplay} from "./RatingCommentDisplay";
import {RatingsAddComment} from "./RatingsAddComment";
import {RatingLikertScaleFeedback} from "./RatingLikertScaleFeedback";
import {RatingsOverrideScore} from "./RatingsOverrideScore";
import {OverrideScoreView} from "./OverrideScoreView";
import {RatingNotApplicable} from "./RatingNotApplicable";
import {RatingNotApplicableView} from "./RatingNotApplicableView";

export const RatingCriteriaDetails = ({
                                          criteria,
                                          suppliers,
                                          userInfo,
                                          isSupplierMimic,
                                            isSupplierAdmin,
                                          isActionsAllowed,
                                          criteriaComments,
                                          isAddCommentOpen,
                                          isEditCommentOpen,
                                          isOverrideScoreOpen,
                                          isEditOverrideScoreOpen,
                                          onActions,
                                          originalValue,
                                          overrideValue,
                                          onOverrideActions,
                                          isNotApplicableOpen,
                                          isEditNotApplicableOpen,
                                          onNotApplicableActions,
                                          likertScaleData
                                      }) => {

    const classes = useStyles();
    const [expanded, setExpanded] = useState('panel1');
    const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
    const loggedInUser = userInfo && userInfo.userId;
    const [criteriaComment, setCriteriaComment] = useState(null);
    const [commentsCount, setCommentsCount] = useState(0)

    const getLikertScaleList = (likertScaleLength) => {
        switch (likertScaleLength) {
            case 5:
                return LIKERT_SCALE_LIST;
            case 4:
                return LIKERT_SCALE_LIST_4;
            case 3:
                return LIKERT_SCALE_LIST_3;
            case 2:
                return LIKERT_SCALE_LIST_2;
            default:
                return LIKERT_SCALE_LIST;
        }
    }

    const likertScaleList = criteria.custLikertRanges ? getLikertScaleList(criteria.custLikertRanges.length) : LIKERT_SCALE_LIST;

    const sortedFeedbacks = criteria.feedbacks && criteria.feedbacks.sort((a, b) => {
        let descA,
            descB
        if (criteria.responseType.id === 1) {
            descA = b.feedback.yesNoChoice.toLowerCase()
            descB = a.feedback.yesNoChoice.toLowerCase()
        } else if (criteria.responseType.id === 2 || criteria.responseType.id === 4) {
            descA = b.feedback.rating.toLowerCase()
            descB = a.feedback.rating.toLowerCase()
        }
        return sortAlphaNum(descA, descB)
    })

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : 'panel1');
    };

    const handleStateData = (data) => {
        onActions(data, criteria.id, "visibility")
    }

    const handleCommentsAction = (value, commentId, type) => {
        onActions(value, commentId, type)
    }

    const handleOverrideScoreAction = (data, type) => {
        onOverrideActions(data, type)
    }

    const handleNotApplicableAction = (data, type) => {
        onNotApplicableActions(data, type)
    }

    useEffect(() => {
            if (userInfo && (userInfo.isSupplier || isSupplierMimic) && criteria.responseType.id === 1) {
                setFilteredFeedbacks(criteria.feedbacks.filter(item => item.feedback.yesNoChoice !== ""))
            } else if (userInfo && (userInfo.isSupplier || isSupplierMimic) && (criteria.responseType.id === 2 || criteria.responseType.id === 4)) {
                setFilteredFeedbacks(criteria.feedbacks.filter(item => item.feedback.rating !== ""))
            } else {
                setFilteredFeedbacks(criteria.feedbacks)
            }
        },// eslint-disable-next-line react-hooks/exhaustive-deps
        [criteria.feedbacks, isSupplierMimic])

    useEffect(() => {
            const commentObj = criteriaComments && criteriaComments.filter(item => {
                return Object.keys(item.user).length !== 0 && item.user.racfID.toUpperCase() === loggedInUser.toUpperCase()
            })[0];
            setCriteriaComment(commentObj)

            const allComments = criteria.feedbacks.filter(item => item.feedback.comment !== "")
            setCommentsCount(allComments.length + criteriaComments.length)

        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [loggedInUser, criteriaComments]);

    return <AccordionDetails
        className={suppliers.length === 1 ? classes.singleAccordionDetails : classes.accordionDetails}>
        <Grid container alignItems="center" spacing={2}>
            {isAddCommentOpen &&
            <Grid item xs={12}>
                <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                    <RatingsAddComment
                        placeholder=""
                        criteriaComment={criteriaComment}
                        criteriaId={criteria.id}
                        onCommentsAction={handleCommentsAction}/>
                </Box>
            </Grid>
            }
            {isEditCommentOpen &&
            <Grid item xs={12}>
                <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                    <RatingsAddComment
                        placeholder=""
                        isEdit={true}
                        criteriaComment={criteriaComment}
                        criteriaId={criteria.id}
                        onCommentsAction={handleCommentsAction}/>
                </Box>
            </Grid>
            }
            {isOverrideScoreOpen &&
            <Grid item xs={12}>
                <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                    <RatingsOverrideScore
                        criteriaId={criteria.id}
                        suppliers={suppliers}
                        originalValue={originalValue}
                        overrideValue={overrideValue}
                        onOverrideScoreAction={handleOverrideScoreAction}
                        criteria={criteria}
                    />
                </Box>
            </Grid>
            }
            {isEditOverrideScoreOpen &&
            <Grid item xs={12}>
                <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                    <RatingsOverrideScore
                        criteriaId={criteria.id}
                        suppliers={suppliers}
                        originalValue={originalValue}
                        overrideValue={overrideValue}
                        isEdit={true}
                        criteria={criteria}
                        onOverrideScoreAction={handleOverrideScoreAction}
                    />
                </Box>
            </Grid>
            }
            {isNotApplicableOpen &&
            <Grid item xs={12}>
                <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                    <RatingNotApplicable
                        criteriaId={criteria.id}
                        suppliers={suppliers}
                        onNotApplicableAction={handleNotApplicableAction}
                        criteria={criteria}
                    />
                </Box>
            </Grid>
            }
            {isEditNotApplicableOpen &&
            <Grid item xs={12}>
                <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                    <RatingNotApplicable
                        criteriaId={criteria.id}
                        suppliers={suppliers}
                        onNotApplicableAction={handleNotApplicableAction}
                        criteria={criteria}
                        isEdit={true}
                    />
                </Box>
            </Grid>
            }
            <Grid item xs={12} style={{paddingLeft: "2rem"}}>
                <Grid container spacing={1}>
                    {likertScaleData && likertScaleData.map((item) => {
                        return (
                            <Grid item xs key={`likert-desc-${criteria.id}-${item.level}`}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="label"
                                                    size="md">
                                            {likertScaleList.filter(ele => ele.selected === item.level)[0].name} {`(${item.level})`}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography color="primary" size="sm">{item.description}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    })
                    }
                </Grid>
            </Grid>
            <Grid item xs={12}>
                {!(userInfo && userInfo.isSupplier) && !isSupplierMimic && criteria.overrideReason && !isOverrideScoreOpen && !isEditOverrideScoreOpen && (
                    <OverrideScoreView criteria={criteria}/>
                )}
                {criteria.notApplicableReason && !isNotApplicableOpen && !isEditNotApplicableOpen && (
                    <RatingNotApplicableView criteria={criteria}/>
                )}
                <List disablePadding component="nav"
                      aria-label="supplier list"
                      className={classes.root}>
                    {isActionsAllowed && (suppliers.length === 1 ? commentsCount > 0 : criteriaComments.length > 0) && !isSupplierMimic && (
                        <ListItem divider style={{padding: '0rem'}} key={"-1"}>
                            <Grid container alignItems="center">
                                <Grid item xs={1} style={{
                                    maxWidth: '5%'
                                }}>
                                    <IconButton aria-label="visibility" disabled>
                                        <VisibilityIcon/>
                                    </IconButton>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography variant="label" size="md">
                                        {COMMENT_VISIBLE_TITLE}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </ListItem>
                    )}
                    {criteriaComments && criteriaComments.map((criteriaCommentObj, index) => {
                        return <React.Fragment key={criteriaCommentObj.id}>
                            {(isEditCommentOpen && criteriaCommentObj.user.racfID === loggedInUser)
                                ? <></>
                                : <RatingCommentDisplay
                                    index={index}
                                    criteriaComment={criteriaCommentObj}
                                    suppliers={suppliers}
                                    loggedInUser={loggedInUser}
                                    isDivider={criteriaComments.length > 1}
                                    isActionsAllowed={isActionsAllowed}
                                    onCommentsAction={handleCommentsAction}
                                    isSupplierMimic={isSupplierMimic}
                                />
                            }
                        </React.Fragment>;
                    })}
                    {suppliers.length === 1 && (
                        <>
                            {sortedFeedbacks && filteredFeedbacks && filteredFeedbacks.map((item, index) => {
                                return (
                                    <>
                                        {criteria.responseType.id === 1 &&
                                        <RatingYesNoFeedback
                                            feedback={item}
                                            key={index}
                                            criteria={criteria}
                                            isActionsAllowed={isActionsAllowed}
                                            updateVisibilityState={handleStateData}
                                            isSupplierMimic={isSupplierMimic}
                                            isSupplierAdmin={isSupplierAdmin}/>
                                        }
                                        {criteria.responseType.id === 2 &&
                                        <RatingLikertScaleFeedback
                                            feedback={item}
                                            key={index}
                                            criteria={criteria}
                                            isActionsAllowed={isActionsAllowed}
                                            updateVisibilityState={handleStateData}
                                            isSupplierMimic={isSupplierMimic}
                                            isSupplierAdmin={isSupplierAdmin}/>
                                        }
                                        {criteria.responseType.id === 4 &&
                                            <RatingLikertScaleFeedback
                                                feedback={item}
                                                key={index}
                                                criteria={criteria}
                                                isActionsAllowed={isActionsAllowed}
                                                updateVisibilityState={handleStateData}
                                                isSupplierMimic={isSupplierMimic}
                                                isSupplierAdmin={isSupplierAdmin}/>
                                        }
                                    </>
                                )
                            })}
                        </>
                    )}
                </List>
            </Grid>
            {suppliers.length > 1 && (
                <Grid item xs={12}>
                    <Box mt={2} ml={8} mb={2}>
                        {suppliers.map((supplierData) => {
                            const supplierFeedbacks = criteria.feedbacks.filter(item => item.supplierNumber === supplierData.supplierNumber)
                            let responses,
                                totalYesOrNo,
                                chartData,
                                noOfYes,
                                averageStarRating,
                                averagePointRange,
                                minLikertRangeList,
                                minLikertRange,
                                maxLikertRange,
                                recordedResponses
                            if (criteria.responseType.id === 1) {
                                responses = supplierFeedbacks.filter(item => item.feedback.notApplicable === true || item.feedback.declined === true || item.feedback.yesNoChoice !== "")
                                noOfYes = supplierFeedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.yesNoChoice === "Y").length
                                const noOfNoResponses = supplierFeedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.yesNoChoice === "N").length
                                totalYesOrNo = supplierFeedbacks.filter(item => item.feedback.notApplicable === false && (item.feedback.yesNoChoice === "N" || item.feedback.yesNoChoice === "Y")).length
                                chartData = {
                                    labels: ["Yes", "No"],
                                    datasets: [{
                                        data: [noOfYes, noOfNoResponses],
                                        backgroundColor: ["#006400", "#FFDE00"],
                                        borderWidth: [0, 0]
                                    }]
                                }
                            } else if (criteria.responseType.id === 2) {
                                responses = supplierFeedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.rating !== "");
                                averageStarRating = responses.length > 0 && responses.reduce((total, next) => total + parseInt(next.feedback.rating), 0) / responses.length;
                                recordedResponses = supplierFeedbacks.filter(item => item.feedback.notApplicable === true || item.feedback.declined === true || item.feedback.rating !== "")
                            } else if (criteria.responseType.id === 4) {
                                responses = supplierFeedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.rating !== "");
                                averagePointRange = responses?.length > 0 && (responses.reduce((total, next) => total + parseInt(next.feedback.custLikertPointRange), 0) / (responses.length * 100)) * 100;
                                minLikertRangeList = criteria.custLikertRanges?.filter(custLikertRange => custLikertRange?.pointsRange < averagePointRange);
                                // minLikertRange = minLikertRangeList?.at(minLikertRangeList.length - 1);
                                minLikertRange = minLikertRangeList?.sort((a, b) => a.order > b.order ? 1 : -1).at(minLikertRangeList.length - 1);
                                // maxLikertRange = criteria.custLikertRanges?.filter(custLikertRange => custLikertRange?.pointsRange >= averagePointRange).at(0);
                                maxLikertRange = criteria.custLikertRanges?.filter(custLikertRange => custLikertRange?.pointsRange >= averagePointRange).sort((a, b) => a.order > b.order ? 1 : -1).at(0);
                                averageStarRating = minLikertRange?.pointsRange === maxLikertRange?.pointsRange ? 1 : minLikertRange?.order + (averagePointRange - minLikertRange?.pointsRange)/(maxLikertRange?.pointsRange - minLikertRange?.pointsRange);
                                recordedResponses = supplierFeedbacks.filter(item => item.feedback.notApplicable === true || item.feedback.declined === true || item.feedback.rating !== "")
                            }

                            const allComments = supplierFeedbacks.filter(item => item.feedback.comment !== "")
                            const visibleComments = supplierFeedbacks.filter(item => item.feedback.isCommentVisible)
                            const commentsCount = isSupplierAdmin ? allComments.length : visibleComments.length

                            return (
                                <CardContent
                                    style={{padding: 0, marginTop: 10}} key={supplierData.supplierNumber}>
                                    <div className={classes.root}>
                                        <Accordion
                                            expanded={expanded === `panel${supplierData.supplierNumber}`}
                                            onChange={supplierFeedbacks.length !== 0 ?
                                                handleChange(`panel${supplierData.supplierNumber}`) :
                                                () => {
                                                }}>
                                            <AccordionSummary
                                                className={classes.accordionSummary}
                                                classes={{
                                                    expandIcon: classes.expandIcon,
                                                    content: classes.nestedContent,
                                                    expanded: classes.expanded
                                                }}
                                                expandIcon={<ExpandMoreIcon/>}
                                                aria-controls="panel1bh-content"
                                                id="panel1bh-header"
                                            >
                                                <Grid container alignItems="flex-start">
                                                    <Grid item xs={12} md={8}>
                                                        <Typography fontWeight="semibold">
                                                            {supplierData.supplierName} - {parseInt(supplierData.supplierNumber)}
                                                        </Typography>
                                                    </Grid>
                                                    {criteria.responseType.id === 1 &&
                                                    <RatingCampaignsData
                                                        supplierData={supplierData}
                                                        supplierFeedbacks={supplierFeedbacks}
                                                        ChartsGraphs={ChartsGraphs}
                                                        chartData={chartData}
                                                        criteria={criteria}
                                                        noOfYes={noOfYes}
                                                        totalYesOrNo={totalYesOrNo}
                                                        recordedResponses={responses}
                                                        isResponseCountVisible={!userInfo.isSupplier && !isSupplierMimic}
                                                        responses={responses}
                                                        commentsCount={commentsCount}/>
                                                    }
                                                    {criteria.responseType.id === 2 &&
                                                    <RatingCampaignsData
                                                        supplierData={supplierData}
                                                        supplierFeedbacks={supplierFeedbacks}
                                                        responses={responses}
                                                        averageStarRating={averageStarRating}
                                                        recordedResponses={recordedResponses}
                                                        commentsCount={commentsCount}
                                                        isResponseCountVisible={!userInfo.isSupplier && !isSupplierMimic}
                                                        type={"likertScale"}
                                                        isActionsAllowed={isActionsAllowed}/>
                                                    }
                                                    {criteria.responseType.id === 4 &&
                                                    <RatingCampaignsData
                                                        supplierData={supplierData}
                                                        supplierFeedbacks={supplierFeedbacks}
                                                        responses={responses}
                                                        averageStarRating={averageStarRating}
                                                        recordedResponses={recordedResponses}
                                                        commentsCount={commentsCount}
                                                        isResponseCountVisible={!userInfo.isSupplier && !isSupplierMimic}
                                                        type={"likertScale"}
                                                        isActionsAllowed={isActionsAllowed}/>
                                                    }
                                                </Grid>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        <List disablePadding component="nav"
                                                              aria-label="supplier feedback list"
                                                              className={classes.root}>
                                                            {isActionsAllowed && !isSupplierMimic && (
                                                                <ListItem divider style={{padding: '.5rem 0rem'}}
                                                                          key={"-1"}>
                                                                    <Grid container alignItems="center">
                                                                        <Grid item xs={1} style={{
                                                                            maxWidth: '5%'
                                                                        }}>
                                                                            <IconButton aria-label="visibility"
                                                                                        disabled>
                                                                                <VisibilityIcon/>
                                                                            </IconButton>
                                                                        </Grid>
                                                                        <Grid item xs={11}>
                                                                            <Typography variant="label" size="md">
                                                                                {COMMENT_VISIBLE_TITLE}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </ListItem>
                                                            )}
                                                            {sortedFeedbacks && filteredFeedbacks && filteredFeedbacks.map((item, index) => {
                                                                if (item.supplierNumber !== supplierData.supplierNumber)
                                                                    return null;
                                                                return <React.Fragment key={`${item.campaignId}-${criteria.id}-${item.stakeholder.user.racfID}-${index}`}>
                                                                    {criteria.responseType.id === 1 &&
                                                                    <RatingYesNoFeedback
                                                                        feedback={item}
                                                                        itemIndex={index}
                                                                        key={`${index}h1`}
                                                                        criteria={criteria}
                                                                        isActionsAllowed={isActionsAllowed}
                                                                        updateVisibilityState={handleStateData}
                                                                        isSupplierMimic={isSupplierMimic}
                                                                        isSupplierAdmin={isSupplierAdmin}/>
                                                                    }
                                                                    {criteria.responseType.id === 2 &&
                                                                    <RatingLikertScaleFeedback
                                                                        feedback={item}
                                                                        itemIndex={index}
                                                                        key={`${index}h2`}
                                                                        criteria={criteria}
                                                                        isActionsAllowed={isActionsAllowed}
                                                                        updateVisibilityState={handleStateData}
                                                                        isSupplierMimic={isSupplierMimic}
                                                                        isSupplierAdmin={isSupplierAdmin}/>
                                                                    }
                                                                    {criteria.responseType.id === 4 &&
                                                                    <RatingLikertScaleFeedback
                                                                        feedback={item}
                                                                        itemIndex={index}
                                                                        key={`${index}h3`}
                                                                        criteria={criteria}
                                                                        isActionsAllowed={isActionsAllowed}
                                                                        updateVisibilityState={handleStateData}
                                                                        isSupplierMimic={isSupplierMimic}
                                                                        isSupplierAdmin={isSupplierAdmin}/>
                                                                    }
                                                                </React.Fragment>;
                                                            })}
                                                        </List>
                                                    </Grid>
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                </CardContent>
                            )
                        })}
                    </Box>
                </Grid>
            )}
        </Grid>
    </AccordionDetails>
}
